import { WindowTitle } from "@dashboard/components/WindowTitle";
import { useCartSnapshotPromoteToDraftMutation, useCartSnapshotsQuery } from "@dashboard/graphql";
import useNavigator from "@dashboard/hooks/useNavigator";
import useNotifier from "@dashboard/hooks/useNotifier";
import { commonMessages } from "@dashboard/intl";
import { orderUrl } from "@dashboard/orders/urls";
import { mapEdgesToItems } from "@dashboard/utils/maps";
import { FC } from "react";
import { useIntl } from "react-intl";

import { CartVisibilityDetailsPage } from "../components/CartVisibilityDetailsPage";
import { messages } from "../components/CartVisibilityDetailsPage/messages";

interface CartVisibilityDetailsViewProps {
  id: string;
}

export const CartVisibilityDetailsView: FC<CartVisibilityDetailsViewProps> = ({ id }) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const intl = useIntl();

  const { data, loading } = useCartSnapshotsQuery({
    variables: { first: 100 },
    fetchPolicy: "cache-and-network",
  });

  const [promote, promoteOpts] = useCartSnapshotPromoteToDraftMutation({
    onCompleted: result => {
      const payload = result.cartSnapshotPromoteToDraft;

      if (payload?.order && (payload.errors?.length ?? 0) === 0) {
        navigate(orderUrl(payload.order.id));
      } else {
        notify({
          status: "error",
          text: intl.formatMessage(commonMessages.somethingWentWrong),
        });
      }
    },
  });

  const carts = mapEdgesToItems(data?.cartSnapshots) ?? [];
  const cart = carts.find(node => node.id === id);

  const title = cart?.email ?? intl.formatMessage(messages.anonymous);

  return (
    <>
      <WindowTitle title={title} />
      <CartVisibilityDetailsPage
        cart={cart}
        loading={loading}
        promoting={promoteOpts.loading}
        onTakeOver={token => promote({ variables: { token } })}
        onOrderClick={orderId => navigate(orderUrl(orderId))}
      />
    </>
  );
};

export default CartVisibilityDetailsView;
